module.exports = __webpack_public_path__ + "static/media/olake-home.93e929f6.svg";